var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',{attrs:{"no-gutters":""}},[_c('v-col',{staticStyle:{"text-align":"center"},attrs:{"cols":"12","sm":"12","md":"12"}},[_c('img',{attrs:{"src":_vm.qrCodeDataString}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }